var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('input',{staticClass:"page-date-picker",attrs:{"type":"date","required":""},domProps:{"value":_vm.inComingDate},on:{"change":_vm.dateChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }